import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		text: {
			fontSize: 18,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		callout: {
			display: "flex",
			gap: theme.spacing(1),
			padding: theme.spacing(2),
			borderRadius: 4,
			backgroundColor: theme.palette.custom.warningLight,
		},
		calloutIcon: {
			flexShrink: 0,
			marginTop: theme.spacing(0.5),
			color: theme.palette.custom.tagWarningText,
		},
		copyValue: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(0.5),
			padding: theme.spacing(2),
			borderRadius: 8,
			backgroundColor: theme.palette.custom.tableHeaderSurface,
		},
		copyLabel: {
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textSecondary,
		},
		copyRow: {
			display: "flex",
			alignItems: "center",
			flexWrap: "wrap",
			gap: theme.spacing(1),
		},
		copyValueText: {
			fontSize: 18,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
			wordBreak: "break-all",
		},
		copyButton: {
			padding: 0,
			minWidth: 0,
			"& .MuiButton-startIcon": {
				marginLeft: 0,
				marginRight: theme.spacing(0.5),
			},
		},
		link: {
			display: "inline-flex",
			alignItems: "center",
			gap: theme.spacing(0.5),
			verticalAlign: "baseline",
		},
		list: {
			margin: 0,
			paddingLeft: theme.spacing(3),
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
			"& > li": {
				paddingLeft: theme.spacing(0.5),
			},
			"& > li > *:not(:first-child)": {
				marginTop: theme.spacing(2),
			},
		},
	} satisfies Record<string, CSSObject>);
};
